<template>
  <div class="sidebar">
    <div class="logo">
      <i></i>
      <span>商业精密客流分析</span>
    </div>
    <el-menu
      :default-active="active"
      :collapse="$store.state.sidebarCollapse || $store.state.appMiniWidth"
      @select="selectMenuItem"
    >
      <sidebar-items :items="items"></sidebar-items>
    </el-menu>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import SidebarItems from '@/components/SidebarItems.vue';

  export default {
    name: 'Sidebar',
    data() {
      return {
        active: null,
        items: []
      }
    },
    mounted() {
      CommonService.sidebar().then(res => {
        this.items = [
          {
            menu_icon: 'el-icon-stopwatch',
            menu_name: '控制台',
            menu_route: '/dashboard'
          }
        ].concat(res.data);
        this.initMenuItem();
      }).catch(() => {});
    },
    watch: {
      $route(newVal, oldVal) {
        this.initMenuItem();
      }
    },
    components: {
      SidebarItems
    },
    methods: {
      initMenuItem() {
        this.depthSearchTree(
          node => {
            if (node.menu_route && node.menu_route.split('/')[1] === this.$route.path.split('/')[1]) {
              this.active = node.menu_route;
            }
          },
          this.items,
          '_child'
        );
      },
      selectMenuItem(path) {
        this.$router.push({
          path
        }, () => {}, () => {});
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .sidebar {
    background-color: @color-white;
    box-shadow: @box-shadow-1;
    .logo {
      font-size: 21px;
      padding: 15px @distance;
      white-space: nowrap;
      overflow: hidden;
      & > * {
        display: inline-block;
        vertical-align: middle;
      }
      i {
        .setImg('/common/logo.png');
        width: 32px;
        height: 32px;
        margin-right: @distance;
      }
    }
  }
</style>